import type { QueryClient } from "@tanstack/react-query";

/**
 * Marca como vencidos los dos listados de operaciones que hay en el portal.
 *
 * Hay dos, con claves distintas y sin relación entre sí:
 *
 * - `["operations", ...]` es la tabla del tablero (`useInfiniteQueryGetOperations`).
 * - `["getOperations", ...]` es el listado plano (`useGetOperations`), que usa
 *   la impresión en lote.
 *
 * React Query invalida por prefijo de clave, y `"getOperations"` no es prefijo
 * de `"operations"`: son dos strings distintos. Los avisos que llegan por
 * socket invalidaban sólo el segundo, así que **la tabla no se enteraba de
 * nada que hiciera el médico**. La fila podía quedar en «Con el médico» un
 * rato largo después de que la evaluación ya estaba cerrada, hasta que el
 * enfermero tocara algo o volviera a entrar a la pantalla — y volver a la
 * pestaña tampoco alcanzaba, porque el listado tiene
 * `refetchOnWindowFocus: false`.
 *
 * Lo que sí la refrescaba eran las acciones del propio enfermero, que pasan
 * por un `invalidateQueries()` sin clave y por lo tanto invalidan todo. Por eso
 * el desajuste no se notaba mirando el flujo del enfermero solo.
 *
 * Pasa por acá y no repetido en cada lugar para que no vuelva a desalinearse:
 * si mañana aparece un tercer listado, se agrega en un solo lugar.
 */
export function invalidarListadoDeOperaciones(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ["operations"] });
  queryClient.invalidateQueries({ queryKey: ["getOperations"] });
}
